import { useState, useEffect, useRef } from 'react'
import { API, API_ROUTER } from '../../../../../api'

export const useUserRating = (id, userPublicGames, selectedGame) => {
  const [rating, setRating] = useState([])
  const mountedRef = useRef(true)
  const abortControllerRef = useRef(null)

  const getRatingStatistic = async () => {
    if (id === undefined || !mountedRef.current) {
      return
    }

    // Cancel previous request if it exists
    if (abortControllerRef.current) {
      abortControllerRef.current.abort()
    }

    abortControllerRef.current = new AbortController()
    const signal = abortControllerRef.current.signal

    const gameId = userPublicGames
      ?.filter(game => selectedGame === game.game.title)
      .map(game => game.game.id)

    try {
      const res = await API.request({
        ...API_ROUTER.rating.getRatingTable,
        pathKeys: {
          page: 1,
          limit: 1,
        },
        data: {
          userId: id,
          gameId: gameId[0],
        },
        signal,
      })
      if (mountedRef.current && !signal.aborted) {
        setRating(res.rows.length > 0 ? res.rows[0] : [])
      }
    } catch (err) {
      if (!signal.aborted) {
        console.log(err)
      }
    }
  }

  useEffect(() => {
    getRatingStatistic()

    return () => {
      mountedRef.current = false
      if (abortControllerRef.current) {
        abortControllerRef.current.abort()
      }
    }
  }, [id])

  useEffect(() => {
    if (mountedRef.current) {
      getRatingStatistic()
    }
  }, [selectedGame])

  return {
    rating,
    getRatingStatistic,
  }
}
